import { NgModule } from '@angular/core';
import { LoadingPlatformModule } from '../../../src/app/core/loading/loading-platform.module';

@NgModule({
  imports: [LoadingPlatformModule],
  exports: [LoadingPlatformModule],
})
export class LoadingModule {}
